import React, { useEffect, useState } from "react";
import CookieManager from "../../services/CookieManager";
import { toast } from "react-toastify";
import { ErrorToast, WarningToast } from "../../pure-components/CustomToast";
import Helper from "../../services/helper";
import { useHistory } from "react-router-dom";
import { BouncingLoader } from "../../pure-components/Loader";
import PaymentHistory from "./paymentHistory";
import API from "../../services/api";
import { Link } from "react-router-dom/cjs/react-router-dom";

const formatDate = (ms) =>
  new Date(ms).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

const getTimeUntil = (expiryMs) => {
  const now = Date.now();
  const diff = expiryMs - now;
  if (diff <= 0) return "Expired";
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const months = Math.floor(days / 30);
  return months > 0 ? `in ${months} month${months > 1 ? "s" : ""}` : `in ${days} day${days > 1 ? "s" : ""}`;
};

const getStatusBadge = (status) => {
  const lower = status.toLowerCase();
  const common = "px-4 py-1 rounded-full text-sm font-semibold inline-block";
  if (lower === "success") return `${common} bg-green-100 text-green-800`;
  if (lower === "pending") return `${common} bg-yellow-100 text-yellow-800`;
  if (lower === "failed") return `${common} bg-red-100 text-red-800`;
  return `${common} bg-gray-200 text-gray-800`;
};

const getSubscriptionBadge = (active, large = false) => {
  const baseSize = large ? "text-base" : "text-sm";
  const common = `px-4 py-1 rounded-full ${baseSize} inline-block font-medium`;
  return active
    ? `${common} bg-blue-100 text-blue-800`
    : `${common} bg-gray-300 text-gray-700`;
};

export default function SubscriptionInfo() {
  const history=useHistory();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      await new Promise((res) => setTimeout(res, 300));
      const response = {
        email: "test_01@gmail.com",
        productName: "SOLO_YEARLY",
        productDesc: "Solo Yearly",
        price: 708000,
        interval: "year",
        paymentStatus: "Pending",
        subscriptionStatus: false,
        created: 1749032640951,
        updated: 1749034243591,
        expiry: 1780570243591,
      };
    //   setData(response);
      setLoading(false);
    };
    // fetchData();
    loadSubscriptionData();
  }, []);

  const profileData = JSON.parse(CookieManager.getCookie("user-data") || "{}"); 
    
  const loadSubscriptionData =async()=> {
    const xAccessToken = CookieManager.getCookie("x-access-token");
    if(!profileData || !profileData?.email || profileData?.email?.length === 0){
        toast(({ closeToast }) => <ErrorToast message={"User profile loading error, Please login again."} />);
        setData(null);
        setLoading(false);
        history.push("/login");
        return;
    }

    await fetch(`${process.env.REACT_APP_BASE_URL}api/users/subscription/${Helper.encode(profileData.email)}/true`, 
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': xAccessToken,
                'x-auth': xAccessToken,
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0',
            }
        }
    )
    .then(response => {
        // console.log("response : ", response);
        return response.json(); 
    })
    .then(resp => {
        console.log('Data received:', resp);
        if(resp?.success){
            setData(resp.data || null);
        }else{
            toast(({ closeToast }) => <WarningToast message={resp.message} />);
        }
    })
    .catch(error => {
        console.error('Subscription data loading error:', error);
        toast(({ closeToast }) => <ErrorToast message={"Subscription data loading error"} />);
    })
    .finally(() => {
        setLoading(false);
    });
  }

  const payForSubscription = async() => {
    await API.payForSubscription(data.id).then((resp)=>{
      if(resp.data?.length > 0){
                        // setPaymentForm(res.data);
        setTimeout(() => {
            const formContainer = document.createElement('div');
            formContainer.innerHTML = resp.data;
            document.body.appendChild(formContainer);
            
            const form = document.getElementById('paymentForm');
            form.submit();
        }, 3000)
      }
    }).catch(err => {
      console.log("Error while payment link creation. ", err);
    })
  }

  if (loading) return <div className="p-10 text-green-600 text-xl justify-center mt-16 lg:w-3/4 sm:w-full"> <BouncingLoader className="w-full flex "/><div className="w-full flex  justify-center">Loading subscription data...</div></div>;
  if (!data) 
    return (<div className="p-10 w-full flex justify-center mt-16 lg:w-3/4 sm:w-full">
        <div className="text-red-600 text-xl ">No subscription data available.</div>
        <div className="text-green-600 text-xl px-4 cursor-pointer">
          <a href={process.env.REACT_APP_MKT_SITE_PRICING}>Subscribe</a>
        </div>
      </div>)

  return (
    <div className="py-6 px-4 flex items-start justify-center canvas lg:w-3/4 sm:w-full">
    <div className="w-full max-w-5xl bg-white shadow-xl rounded-2xl p-6 sm:p-8 space-y-6 border-black border-4">
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
        <div>
            <h2 className="text-4xl font-bold text-gray-800">{data.productDesc}</h2>
            <p className="text-base text-gray-500">{data.productName}</p>
        </div>
        <div className="flex flex-col sm:flex-row justify-end">
          <span className={getSubscriptionBadge(data.subscriptionStatus, true)}>
              {data.subscriptionStatus ? "Active" : "Inactive"}
          </span>
          {profileData.userType !== "FREE" && data.paymentStatus?.toLowerCase() !== "success" &&
            <span className={`mx-1 cursor-pointer ${getSubscriptionBadge(true)}`}
            onClick={() => payForSubscription()}>
              Pay
            </span>}
            
          <a className={`mx-1 cursor-pointer ${getSubscriptionBadge(true)}`}
            href={process.env.REACT_APP_MKT_SITE_PRICING}>
              Change Subscription
          </a>
          
        </div>
        </div>

        {/* Info Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-700 text-lg">
        <div>
            <p className="text-base text-gray-500">Email</p>
            <p className="font-medium break-words">{data.email}</p>
        </div>

        <div>
            <p className="text-base text-gray-500">Interval</p>
            <span className="inline-block bg-yellow-100 text-yellow-800 text-sm px-3 py-0.5 rounded-full">
            {data.interval}
            </span>
        </div>

        <div>
            <p className="text-base text-gray-500">Price</p>
            <span className="inline-block bg-indigo-100 text-indigo-800 text-sm px-3 py-0.5 rounded-full">
            ₹{(data.price / 100).toLocaleString()}
            </span>
        </div>

        <div>
            <p className="text-base text-gray-500">Payment Status</p>
            <span className={getStatusBadge(data.paymentStatus)}>{data.paymentStatus}</span>
        </div>

        <div>
            <p className="text-base text-gray-500">Subscription Status</p>
            <span className={getSubscriptionBadge(data.subscriptionStatus)}>
            {data.subscriptionStatus ? "Active" : "Inactive"}
            </span>
        </div>

        <div>
            <p className="text-base text-gray-500">Created On</p>
            <p>{formatDate(data.created)}</p>   
        </div>

        <div>
            <p className="text-base text-gray-500">Last Updated On</p>
            <p>{formatDate(data.updated)}</p>
        </div>

        <div className="sm:col-span-2 flex flex-col sm:flex-row justify-between items-start sm:items-center">
            <div>
            <p className="text-base text-gray-500">Expires On</p>
            <p>{formatDate(data.expiry)}</p>
            </div>
            {data.paymentStatus === "Success" &&
            <>{getTimeUntil(data.expiry) !== "Expired" ? 
            <span className="mt-2 sm:mt-0 inline-flex px-4 py-1 rounded-full bg-gray-200 text-gray-800 text-sm font-medium">
                Expires {getTimeUntil(data.expiry)}
            </span>
            : <span className="mt-2 sm:mt-0 inline-flex px-4 py-1 rounded-full bg-red-100 text-red-800 text-sm font-medium">
                {getTimeUntil(data.expiry)}
            </span>}
            </>}
        </div>
        </div>

        {/* Payment History */}
        <div>
          <PaymentHistory paymentData={data.paymentHistory} subData = {{...data, paymentHistory : {}}} />
        </div>
    </div>
    </div>
  );
};
